/**
 * Hover HTML for a Vega chart that carries an assurance Level or a Yes/No Status.
 * Any other field is left as the default tooltip text.
 */
import { ASSURANCE_COLORS, getTextColorForBg, type AssuranceLevel } from 'src/features/reporting/utils/color';

const UNKNOWN_LEVEL = '#94a3b8';

function escapeHtml(value: string): string {
  return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function assurancePillHtml(label: string, bg: string): string {
  const fg = getTextColorForBg(bg);
  return `<span style="display:inline-block;padding:2px 8px;border-radius:9999px;font-size:11px;font-weight:500;line-height:1.25;background:${bg};color:${fg};white-space:nowrap">${escapeHtml(label)}</span>`;
}

/** Vega tooltip HTML: render assurance Level (and Yes/No Status) as coloured pills. */
export function formatAssuranceChartTooltip(
  value: unknown,
  valueToHtml: (value: unknown) => string,
  _maxDepth: number
): string {
  if (value == null) return '';
  if (typeof value !== 'object') return valueToHtml(value);

  const rows = Object.entries(value as Record<string, unknown>).map(([key, val]) => {
    let display: string;
    if (key === 'Level' && typeof val === 'string') {
      if (val in ASSURANCE_COLORS && val !== 'NaN') {
        display = assurancePillHtml(val, ASSURANCE_COLORS[val as AssuranceLevel]);
      } else {
        display = assurancePillHtml(val, UNKNOWN_LEVEL);
      }
    } else if (key === 'Status' && (val === 'Yes' || val === 'No')) {
      display = assurancePillHtml(val, val === 'Yes' ? ASSURANCE_COLORS.Substantial : ASSURANCE_COLORS.None);
    } else {
      display = valueToHtml(val);
    }
    return `<tr><td class="key" style="vertical-align:middle;padding-right:10px">${valueToHtml(key)}</td><td class="value" style="vertical-align:middle">${display}</td></tr>`;
  });

  return `<table style="border-collapse:collapse;border-spacing:0">${rows.join('')}</table>`;
}
